const translations = {
    description:
        'At {{gpa}} GPA, product concentration is {{pct}}% v/v. Some labels cap finished-spray concentration; verify before applying.'
};

export default translations;
